/// <reference path="Main.js" />
/// <reference path="Enumeration-vsdoc.js" />

/* global ajaxHelper */

window.JJK = window.JJK || {};

JJK.Reklamation = function (
	BezirkErmittelnURL,
	FormReklamation,
	VerteilschemataErmittelnURL,
	KontrollinstanzErmittelnURL,
	ReklamationMassnahmeErmittelnURL,
	AktuelleSprache,
	ZeigeKalenderAn,
	ReklamationKomplett,
	TelefonNrPflichtfeld,
	setzeAboReklamationAktivUrl,
	KeineVerteilschemataFehlermeldung,
	beginneMitVerteilschema
) {
	this.BezirkErmittelnURL = BezirkErmittelnURL;
	this.FormReklamation = FormReklamation;
	this.VerteilschemataErmittelnURL = VerteilschemataErmittelnURL;
	this.KontrollinstanzErmittelnURL = KontrollinstanzErmittelnURL;
	this.ReklamationMassnahmeErmittelnURL = ReklamationMassnahmeErmittelnURL;
	this.AktuelleSprache = AktuelleSprache;
	this.zeigeKalenderAn = ZeigeKalenderAn;
	this.ReklamationKomplett = ReklamationKomplett;
	this.TelefonNrPflichtfeld = TelefonNrPflichtfeld;
	this.setzeAboReklamationAktivUrl = setzeAboReklamationAktivUrl;
	this.KeineVerteilschemataFehlermeldung = KeineVerteilschemataFehlermeldung;
	this.beginneMitVerteilschema = beginneMitVerteilschema;
	this.behandleVerteilschemataFehlerFunktion = this.beginneMitVerteilschema ? value => this.fehlermeldungBezirkNichtGefunden(value) : value => this.RemoveVerteilschema(value);
	this.getVerteilschemataErgebnisFunktion = this.beginneMitVerteilschema ? data => this.IstSelektiertesVerteilschemaVorhanden(data) : data => this.VerteilschemataRendern(data);
	this.Init();
};

JJK.Reklamation.prototype = {
	Init: function () {
		const self = this;

		this.ErzeugeEvents();
		if (!this.beginneMitVerteilschema) {
			this.GetInformation();
		}
		this.bezirknummern = '';

		$('#addSchemaButton').on('click', function () {
			self.AddSchema($('#SelectedVerteilschema').val());
		});

		$('#reklamationContainer').on('focusin', function () {
			$('#ReklamationInfo').hide();
		});

		const gewaehlteSchemata = $('#GewaehlteVerteilschemata');
		if (gewaehlteSchemata.val()) {
			const aktuelleSchemata = (gewaehlteSchemata.val() || '').split(',');
			gewaehlteSchemata.val('');
			for (let i = 0; i < aktuelleSchemata.length; i++) {
				this.AddSchema(aktuelleSchemata[i]);
			}
		}

		$('#Nachlieferung')
			.on('change', function () {
				if ($(this).prop('checked')) {
					$('#AbweichendeNachlieferadresse, .AbweichendeNachlieferadressecheckbox').show();
				} else {
					$('#AbweichendeNachlieferadresse, .AbweichendeNachlieferadressecheckbox').hide();
					$('#AbweichendeNachlieferadresse').prop('checked', false).triggerHandler('change');
				}
			})
			.triggerHandler('change');

		$('#ReklamationNeu').on('click', () => self.Submit(false));
		$('#ReklamationDuplizieren').on('click', () => self.Submit(true));

		if (this.beginneMitVerteilschema) {
			this.GetVerteilschemata(null, null, data => this.VerteilschemataRendern(data));
		}

		const termineDiv = document.getElementById('termine');
		if (termineDiv) {
			termineDiv.addEventListener('jjk:monatGeaendert', () => {
				this.SetGewaehlteVerteilschemata(this.GetGewaehlteVerteilschemata().join(','));
			});
		}

		this.AnredeLeerzeileAusblenden();
	},

	Submit: function (duplizieren) {
		$('#DatenBeibehalten').val(duplizieren);
		if (!duplizieren) {
			$('#ReklamationNeu').addClass('disabled');
			window.setTimeout(function () {
				scroll_to_element('#errors', 800, false);
			}, 0);
		}
		$('#FormReklamation').trigger('submit');
	},

	AddSchema: function (nummer) {
		if ($(`#schemaList >li.item[data-id="${nummer}"]`).length > 0) {
			return;
		}

		const self = this;

		const text = $(`#SelectedVerteilschema option[VALUE="${nummer}"]`).text();
		const newEntry = $('.schemaEntryProto').clone().removeClass('schemaEntryProto').addClass('item').attr('data-id', nummer);
		$('.schemaName', newEntry).text(text);

		const removeButton = $('#removeSchemaButton', newEntry);
		removeButton.removeAttr('id');
		removeButton.on('click', function () {
			$(this).parents('.item').remove();
			self._changeSchemaSelection();
			if ($('#GewaehlteVerteilschemata').val() === '') {
				$('#schemaList').hide();
			}
		});

		$('#schemaList').append(newEntry);
		$('#schemaList').show();
		this._changeSchemaSelection();
	},

	_changeSchemaSelection: function () {
		const self = this;

		const aktuelleAuswahl = $.map($('#schemaList >li.item'), function (element) {
			return $(element).attr('data-id');
		});

		if (aktuelleAuswahl.length <= 0) {
			$('#keinSchema').show();
		} else {
			$('#keinSchema').hide();
		}

		const neueAuswahl = aktuelleAuswahl.join(',');
		self.SetGewaehlteVerteilschemata(neueAuswahl, true);
		self.GetKontrollinstanzen($('#GewaehltesBezirk').val(), neueAuswahl.split(','));
	},

	ErzeugeEvents: function () {
		const self = this;
		$('#Strasse').on('blur', function () {
			self.GetInformation();
		});
		$('#Hausnummer').on('blur', function () {
			self.GetInformation();
		});
		$('#PLZ').on('blur', function () {
			self.GetInformation();
		});
		$('#Ort').on('blur', function () {
			self.GetInformation();
		});
		$('#BezirkListe').on('change', function () {
			self.GetInformation();
		});
		$('#GewaehlterGrund').on('change', function () {
			self.GetReklamationMassnahme($('#GewaehlterGrund').val(), $('#GewaehlteReklamationsArt').val());
		});
		$('#GewaehlteReklamationsArt').on('change', function () {
			self.GetReklamationMassnahme($('#GewaehlterGrund').val(), $('#GewaehlteReklamationsArt').val());
		});
		$('#reklamationContext .nav-item').on('click', function (e) {
			self.WechselReklamationsModus(e.currentTarget.id);
		});
		$('#GewaehlteVerteilschemata').on('change', function () {
			$('#AnzahlGewaehlteVerteilschemata').val($(this).val().split(',').length);
			if (!self.ReklamationKomplett && !self.keinGetInformationAufrufen) {
				if (self.TermineNachZusatzEinschraenken($(this).val())) {
					self.LoescheDatum();
				}
				self.GetInformation(!self.beginneMitVerteilschema);
			}
			self.keinGetInformationAufrufen = false;
		});
	},

	AdresseGeaendert: function (strasse, hsNr, plz, ort) {
		return strasse !== this.letzterWertStrasse || hsNr !== this.letzterWertHsNr || plz !== this.letzterWertPLZ || ort !== this.letzterWertOrt;
	},

	// verteilschemaNichtErmitteln: Sonst würde Klick auf Verteilschema bewirken, dass die anderen Verteilschemata ggf. verschwinden, weil durch das selektierte Verteilschema der Bezirk eingeschränkt wird.
	// Wenn beginneMitVerteilschema = true, muss verteilschemaNichtErmitteln false sein, weil in diesem Fall GetVerteilschemata mit IstSelektiertesVerteilschemaVorhanden() aufgerufen wird,
	// um Fehlermeldungen zu erzeugen.
	GetInformation: function (verteilschemaNichtErmitteln) {
		const self = this;
		const strasse = $('#Strasse').val();
		const hsNr = $('#Hausnummer').val();
		const plz = $('#PLZ').val();
		const ort = $('#Ort').val();
		if (this.ReklamationKomplett && this.mehrereBezirkeWaehlbar) {
			$('#GewaehltesBezirk').val($('#BezirkListe :selected').text());
		}
		const verteilschema = this.ReklamationKomplett ? null : $('#GewaehlteVerteilschemata').val();
		if (this.AdresseGeaendert(strasse, hsNr, plz, ort) || verteilschema !== this.letzterWertVerteilschema) {
			if (strasse !== '' && hsNr !== '' && plz !== '' && ort !== '') {
				this.GetBezirk(strasse, hsNr, plz, ort, verteilschema, function (fehler) {
					self.behandleVerteilschemata(verteilschemaNichtErmitteln, fehler);
				});
				this.setzeAdresse(strasse, hsNr, plz, ort, verteilschema);
				return;
			} else {
				this.RemoveBezirk();
				this.RemoveKontrollinstanzen();
			}
			this.setzeAdresse(strasse, hsNr, plz, ort, verteilschema);
		}
		this.behandleVerteilschemata(verteilschemaNichtErmitteln, false);
	},

	behandleVerteilschemata: function (verteilschemaNichtErmitteln, fehler) {
		const bezirk = this.ReklamationKomplett ? $('#GewaehltesBezirk').val() : this.bezirknummern;
		if (!verteilschemaNichtErmitteln) {
			if (fehler) {
				this.behandleVerteilschemataFehlerFunktion(true);
			} else if (this.gewaehltesDatum !== this.letzterWertDatum || bezirk !== this.letzterWertBezirk) {
				if (this.gewaehltesDatum != null || (!this.zeigeKalenderAn && bezirk !== '')) {
					// eslint-disable-line no-extra-parens
					this.GetVerteilschemata(bezirk, this.gewaehltesDatum, this.getVerteilschemataErgebnisFunktion);
				} else {
					this.behandleVerteilschemataFehlerFunktion(false);
				}
			}
		}
		this.letzterWertDatum = this.gewaehltesDatum;
		this.letzterWertBezirk = bezirk;
	},

	setzeAdresse: function (strasse, hsNr, plz, ort, verteilschema) {
		this.letzterWertStrasse = strasse;
		this.letzterWertHsNr = hsNr;
		this.letzterWertPLZ = plz;
		this.letzterWertOrt = ort;
		this.letzterWertVerteilschema = verteilschema;
	},

	LoescheDatum: function () {
		this.SetDatum([]);
	},

	SetDatum: function (datum) {
		const data = datum[0];
		if (data) {
			this.gewaehltesDatum = data.id.replace('day_', '');
			$('#OADate').val(this.gewaehltesDatum);
			if (!this.beginneMitVerteilschema) {
				this.GetInformation();
			}
		} else {
			this.gewaehltesDatum = null;
			this.letzterWertDatum = null;
			$('#OADate').val('');
			if (!this.beginneMitVerteilschema) {
				this.RemoveVerteilschema(false);
				this.RemoveKontrollinstanzen();
			}
		}
		$('#ReklamationInfo').hide();
		if (!this.beginneMitVerteilschema) {
			$('#ZeitungWaehlen').hide().removeClass('d-block mb-3');
		}
		this.ValidateElement('#OADate');
	},

	setGewaehltesDatum: function (datum) {
		if (datum !== null) {
			this.gewaehltesDatum = datum;
			$('#OADate').val(datum);
		}
	},

	GetBezirk: function (strasse, hsNr, plz, ort, verteilschema, finished) {
		const self = this;
		ajaxHelper.nurEinRequestUndLetzterInQueue(this.BezirkErmittelnURL, { Strasse: strasse, HsNr: hsNr, PLZ: plz, Ort: ort, verteilschemaId: verteilschema }, function (data) {
			if (data.Bezirk) {
				if (data.Bezirk.length > 1) {
					let listItems = '';
					for (let i = 0; i < data.Bezirk.length; i++) {
						listItems += `<option value='${data.Bezirk[i].Nummer}'>${data.Bezirk[i].Nummer}</option>`;
					}
					self.AktualisiereBezirk(true, data.Bezirk[0].Nummer, listItems, data.Bezirk.map(x => x.Nummer).join(','));
				} else {
					self.AktualisiereBezirk(false, data.Bezirk[0].Nummer, null, data.Bezirk[0].Nummer);
				}
			} else if (data.Fehler) {
				self.RemoveBezirk();
				if (!$('#ReklamationMessageBox').find('.bezirkerror').length && !$('#ReklamationMessageBox').find('.addresserror')) {
					$('#ReklamationMessageBox').append(`<li class ='bezirkerrorItem'><label class ='bezirkerror' style ='display: inline'>${data.Fehler}</label></li>`);
				}
			}
			finished(!!data.Fehler);
		});
	},

	fehlermeldungBezirkNichtGefunden: function (bezirkNichtGefunden) {
		$('#BezirkExistiertFuerVerteilschema').val(bezirkNichtGefunden ? '' : '1');
		if (bezirkNichtGefunden || this.ersterAufrufMitBezirkNichtGefundenTrue) {
			// Erster Aufruf von ValidateElement() muss mit bezirkNichtGefunden = true sein, sonst funktioniert validate danach nicht mehr.
			this.ersterAufrufMitBezirkNichtGefundenTrue = true;
			this.ValidateElement('#BezirkExistiertFuerVerteilschema');
		}
	},

	GetVerteilschemata: function (bezirknummern, gewaehltesDatum, getVerteilschemataErgebnisFunktion) {
		ajaxHelper.nurEinRequestUndLetzterInQueue(this.VerteilschemataErmittelnURL, { OAdatum: gewaehltesDatum, bezirksnummern: bezirknummern }, getVerteilschemataErgebnisFunktion);
	},

	IstSelektiertesVerteilschemaVorhanden: function (data) {
		const gewaehlteVerteilschemata = this.GetGewaehlteVerteilschemata();
		const gewaehltesVerteilschemaWurdeNichtGefunden =
			gewaehlteVerteilschemata.length === 1 && data.Verteilschemata !== null && data.Verteilschemata.find(v => v.Id.toString() === gewaehlteVerteilschemata[0]) === undefined;
		this.fehlermeldungBezirkNichtGefunden(gewaehltesVerteilschemaWurdeNichtGefunden);
	},

	VerteilschemataRendern: function (data) {
		if (data.Datum !== null) {
			this.setGewaehltesDatum(data.Datum);
		}
		if (data.Verteilschemata != null) {
			let listItems = '';
			if (data.Verteilschemata.length > 1) {
				let gewaehlteVerteilschema = this.GetGewaehlteVerteilschemata();
				for (let i = 0; i < data.Verteilschemata.length; i++) {
					listItems += `<option value='${data.Verteilschemata[i].Id}'>${data.Verteilschemata[i].AngezeigterName}</option>`;
				}
				this.AktualisiereVerteilschema(true, '', listItems, data.VerteilschemaLogosHtml);

				if (window.initialVerteilschema) {
					this.SetGewaehlteVerteilschemata(window.initialVerteilschema, true);
					window.initialVerteilschema = null;
				} else {
					gewaehlteVerteilschema = gewaehlteVerteilschema.filter(v => data.Verteilschemata.some(x => x.Id.toString() === v));
					this.SetGewaehlteVerteilschemata(gewaehlteVerteilschema.join(','));
				}
				$('#AnzahlGewaehlteVerteilschemata-error').parent().remove();
			} else if (data.Verteilschemata.length === 1) {
				this.AktualisiereVerteilschema(false, data.Verteilschemata[0].AngezeigterName, listItems, data.VerteilschemaLogosHtml);
				const verteilschemaId = data.Verteilschemata[0].Id;
				this.SetGewaehlteVerteilschemata(verteilschemaId.toString(), true);
				this.GetKontrollinstanzen($('#GewaehltesBezirk').val(), verteilschemaId);
				$('#VerteilschemaLogos').find('input:radio').hide();
				$('#VerteilschemaLogos').find('.from-check-label').addClass('nur-label');
				$('#VerteilschemaLogos').find('.from-check').addClass('p-0');
				$('#AnzahlGewaehlteVerteilschemata-error').parent().remove();
			}
		} else if (data.Fehler) {
			this.RemoveVerteilschema(true);
		}
	},

	GetKontrollinstanzen: function (bezirksNummer, ids) {
		const self = this;
		$.ajax({
			url: this.KontrollinstanzErmittelnURL,
			type: 'POST',
			data: JSON.stringify({ bezirksNummer: bezirksNummer, verteilschemaIds: ids }),
			contentType: 'application/json; charset=utf-8',
			dataType: 'json',
			success: function (data) {
				self.AktualisiereKontrollinstanz(data);
			},
		});
	},

	GetReklamationMassnahme: function (grund, art) {
		const self = this;
		const url = this.ReklamationMassnahmeErmittelnURL;
		$.ajax({
			url: url,
			data: { GrundId: grund, ArtId: art },
			type: 'POST',
			success: function (data) {
				if (data) {
					$('#Ueberwachen').prop('checked', data.Ueberwachen);
					$('#HausinfoKontrollieren').prop('checked', data.HausinfoKontrollieren);
					if (!self.ReklamationKomplett) {
						$('#GewaehlteReklamationsArt').val(data.ArtId);
					}
				}
			},
		});
	},

	AktualisiereBezirk: function (multi, gewaehlterBezirk, listItems, bezirknummern) {
		this.bezirknummern = bezirknummern;
		this.mehrereBezirkeWaehlbar = multi;
		$('.bezirkerrorItem').remove();
		$('#Bezirk').text(gewaehlterBezirk);
		$('#BezirkListe').empty();
		$('#GewaehltesBezirk').val(gewaehlterBezirk);
		if (multi) {
			$('#Bezirk').hide();
			$('#BezirkListe').append(listItems);
			if ($.fn.select2) {
				$('#BezirkListe').next().css('display', 'inline-block');
			} else {
				$('#BezirkListe').show();
			}
		} else {
			$('#Bezirk').show();
			if ($.fn.select2) {
				$('#BezirkListe').next().hide();
			} else {
				$('#BezirkListe').hide();
			}
		}
	},

	AktualisiereVerteilschema: function (multi, gewaehlterVerteilschema, listItems, verteilschemaLogosHtml) {
		const self = this;
		$('.verteilschemaerrorItem').remove();
		$('#SelectedVerteilschema').empty();
		$('#VerteilschemaSpan').html(gewaehlterVerteilschema);
		$('#ZeitungWaehlen').show();
		if (multi) {
			$('#SelectedVerteilschema').append(listItems);
			$('#ZeitungWaehlen').html(Strings.ZeitungWaehlen);
			$('.SelectVerteilschemaDiv').show();
		} else {
			$('#schemaList').hide();
			$('#ZeitungWaehlen').html(Strings.IhreZeitung);
			$('.SelectVerteilschemaDiv').hide();
		}
		const htmlGeaendert = this.SetzeVerteilschemaLogos(verteilschemaLogosHtml);
		if (htmlGeaendert) {
			$('[name="VerteilschemaLogo"]').on('click', function () {
				self.setGewaehltesDatum($(this).data('datum'));
				$('#GewaehlteVerteilschemata').val($(this).val()).triggerHandler('change');
				$('#FormReklamation').validate().element('#GewaehlteVerteilschemata');
			});
		}
		if (convert2BootstrapCheckboxOrRadiobutton_geladen()) {
			$('#ZeitungWaehlen').addClass('d-block mb-3');
			if (htmlGeaendert) {
				$('#VerteilschemaLogos').find('br').remove();
				$('#VerteilschemaLogos')
					.find(':radio')
					.each(function () {
						convert2BootstrapCheckboxOrRadiobutton(this);
					});
			}
		}
	},

	SetzeVerteilschemaLogos: function (verteilschemaLogosHtml) {
		if (this.verteilschemaLogosHtml !== verteilschemaLogosHtml) {
			this.verteilschemaLogosHtml = verteilschemaLogosHtml;
			$('#VerteilschemaLogos').html(verteilschemaLogosHtml);
			return true;
		}
		return false;
	},

	AktualisiereKontrollinstanz: function (data) {
		const self = this;
		self.RemoveKontrollinstanzen();

		if (data.Kontrollinstanzen) {
			$.each(data.Kontrollinstanzen, function (i, kontrollinstanz) {
				const newEntry = $('.kontrollinstanzEntryProto').clone().removeClass('kontrollinstanzEntryProto').attr('class', 'kontrollinstanzEntry');

				$('#KontrollinstanzName', newEntry).text(kontrollinstanz.Name);
				$('#KontrollinstanzTelefon', newEntry).text(kontrollinstanz.Telefon);
				$('#KontrollinstanzMobil', newEntry).text(kontrollinstanz.MobilTelefon);
				$('#KontrollinstanzEmail', newEntry).text(kontrollinstanz.Email);
				$('#Kontrollinstanzen').append(newEntry);
			});

			if (data.Kontrollinstanzen.length > 0) {
				$('.kontrollinstanzen').show();
			}
		}
	},

	RemoveBezirk: function () {
		if ($.fn.select2) {
			$('#BezirkListe').next().hide();
		} else {
			$('#BezirkListe').hide();
		}
		$('#BezirkListe').empty();
		$('#Bezirk').empty();
		$('#GewaehltesBezirk').val('');
		this.bezirknummern = '';
	},

	RemoveKontrollinstanzen: function () {
		$('.kontrollinstanzEntry').remove();
		$('.kontrollinstanzen').hide();
	},

	RemoveVerteilschema: function (validate) {
		if (this.beginneMitVerteilschema) {
			return;
		}
		$('#schemaList').hide();
		$('#schemaList').find('.item').remove();
		$('#VerteilschemaSpan').html('');
		$('.SelectVerteilschemaDiv').hide();
		$('#GewaehlteVerteilschemata').val('');
		$('#ZeitungWaehlen').hide().removeClass('d-block mb-3');
		this.SetzeVerteilschemaLogos('');
		this.SetGewaehlteVerteilschemata('', validate);
	},

	RemoveAll: function () {
		this.RemoveBezirk();
		this.RemoveKontrollinstanzen();
		this.RemoveVerteilschema();
	},

	TermineNachZusatzEinschraenken: function (verteilschema) {
		return this.beginneMitVerteilschema && window.calendar ? window.calendar.TermineNachZusatzEinschraenken(verteilschema) : false;
	},

	SetGewaehlteVerteilschemata: function (value, validate) {
		$('#GewaehlteVerteilschemata').val(value);

		$('#AnzahlGewaehlteVerteilschemata').val(value !== '' ? $('#GewaehlteVerteilschemata').length : 0);

		if (value) {
			this.keinGetInformationAufrufen = true;
			$(`#VerteilschemaLogo_${value}`).trigger('click');
			this.TermineNachZusatzEinschraenken(value);
		}
		if (validate) {
			this.ValidateElement('#AnzahlGewaehlteVerteilschemata');
		}
	},

	ValidateElement: function (element) {
		$(`#${this.FormReklamation}`).validate().element(element);
	},

	GetGewaehlteVerteilschemata: function () {
		const objekt = {};
		$('#schemaList >li.item').each(function (index, element) {
			objekt[$(element).attr('data-id')] = 1;
		});
		const value = $('#GewaehlteVerteilschemata').val();
		if (value) {
			objekt[value] = 1;
		}
		const verteilschemata = [];
		$.each(objekt, function (key, element) {
			verteilschemata.push(key);
		});
		return verteilschemata;
	},

	VerteilschemaLogosWerdenAngezeigt: function () {
		return $('#VerteilschemaLogos input').length > 0;
	},

	JQueryValidationShowErrors: function (verteilschemaFehler, jqueryValidation) {
		// this: JJK.Reklamation.
		const aboReklamationAktiv = JJK.MakeBoolean($('#AboReklamationAktiv').val());
		const self = this;
		function filterMessage(name) {
			jqueryValidation.errorList = $.grep(jqueryValidation.errorList, function (error) {
				return error.element.name !== name;
			});
		}
		// Wenn Validation ein Fehler bei den Verteilschemata zurückgibt, müssen die selbst herstellte Fehlermeldungen zu den Verteilschemata
		// nicht angezeigt werden.
		jqueryValidation.errorList.forEach(function (error) {
			if (error.element.name === 'GewaehlteVerteilschemata' && $('#SelectedVerteilschema option').length < 2 && this.ReklamationKomplett) {
				error.message = verteilschemaFehler;
				$('.verteilschemaerrorItem').remove();
			}
			if (error.element.name === 'AboFuerReklamationId' && !aboReklamationAktiv) {
				filterMessage('AboFuerReklamationId');
			}
			if (error.element.name === 'AnzahlGewaehlteVerteilschemata' && $('#VerteilschemaLogos div').length === 0) {
				error.message = self.KeineVerteilschemataFehlermeldung;
			}
		});
		// Wenn ein Fehler beim ermitteln des Datum vorhanden ist, ist eine Fehlermeldung für das Verteilschema überflüssig
		// Deshalb werden Verteilschema-Fehler ausgeblendet
		if (jqueryValidation.errorList.length === 1 && jqueryValidation.errorList[0].element.name === 'OADate') {
			$('#ReklamationMessageBox li label[for=GewaehlteVerteilschemata]').parent().css('display', 'none');
			$('.verteilschemaerror').parent().remove();
		}
		if ($('#OADate').val() === '') {
			filterMessage('GewaehlteVerteilschemata');
			filterMessage('ReklamationMessageBox');
		}

		// Wenn in der Version für alle Benutzer keine Verteilschemalogos angezeigt werden, dann braucht der Benutzer auch
		// keine Meldung angezeigt bekommen, dass er ein Verteilschema wählen möge.
		if (!this.ReklamationKomplett && !this.VerteilschemaLogosWerdenAngezeigt()) {
			filterMessage('GewaehlteVerteilschemata');
		}
		if (!this.zeigeKalenderAn) {
			// Wenn Kalender nicht angezeigt wird, Fehlermeldung bezüglich der Eingabe eines Datums löschen, denn das Datum ergibt
			// sich automatisch aus Zustellerzuordnung/Verteilschema.
			filterMessage('OADate');
			// Ebenso sollte die Fehlermeldung, dass für das Datum kein Verteilschema gefunden wurde ebenfalls ausgeblendet werden,
			// da der Nutzer kein Verteildatum auswählt. Dass die Adresse Falsch ist, wird ja schon angezeigt. Sollte aus irgendeinanderen Grund
			// dieser Fehler kommen würde das Serverseitig eh abgefangen werden mit eine fehlermeldung
			filterMessage('AnzahlGewaehlteVerteilschemata');
			// Wenn Kalender nicht angezeigt wird, Meldung für Verteilschemata nicht anzeigen, wenn ein Verteilschema selektiert wurde.
			if (this.GetGewaehlteVerteilschemata().length > 0) {
				filterMessage('GewaehlteVerteilschemata');
			}
		}
		if (!aboReklamationAktiv) {
			filterMessage('BenutzerMussEingeloggtSeinFehler');
		}

		jqueryValidation.defaultShowErrors();
	},

	JQueryValidationDynamicallRules: function () {
		// Je nachdem wie der Infoschalter 'Telefonnummer in Onlinereklamation Pflicht' eingestellt ist,
		// werden die Eingabefelder 'Vorwahl' und 'Telefonnummer' validiert, bzw. nicht
		const rulesType = this.TelefonNrPflichtfeld ? 'add' : 'remove';
		$('#Vorwahl').rules(rulesType, 'required');
		$('#TelefonNr').rules(rulesType, 'required');
	},

	WechselReklamationsModus: function (reklamationsModus, init) {
		const self = this;
		if (reklamationsModus === 'reklamationFuerAbo') {
			$('#reklamationsLogin').show();
			$('.nachlieferung').show();
			$('#reklamationAboDaten').show();
			$('#AboReklamationAktiv').val(true);

			$('#reklamationFuerAbo a').addClass('active');
			$('#reklamationFlaechenDeckendVerteilung a').removeClass('active');

			$('#AbweichendeNachlieferadresse').on('change', this.SchalteAbweichendeLieferadresseEinOderAus).triggerHandler('change');

			if (!init && JJK.Login) {
				// nicht nötig / möglich, wenn Login-Formular nicht angezeigt wird, weil User bereits angemeldet ist
				const login = new JJK.Login('LoginButton', 'Login'); // eslint-disable-line no-unused-vars
			}

			$('#BenutzerMussEingeloggtSeinFehler').addClass('validate');

			$.post(this.setzeAboReklamationAktivUrl, { aboReklamationAktiv: true }, function (data) {
				if (window.calendar) {
					window.calendar.termine = data.ErscheinungstermineDaten;
				}
			}).then(self._nachWechselReklamationsModus.bind(self));
		} else if (reklamationsModus === 'reklamationFlaechenDeckendVerteilung') {
			$('#AboReklamationAktiv').val(false);
			$('#reklamationsLogin').hide();
			$('.nachlieferung').hide();
			$('#nachlieferadresse').hide();
			$('#reklamationAboDaten').hide();
			$('#reklamationFlaechenDeckendVerteilung a').addClass('active');
			$('#reklamationFuerAbo a').removeClass('active');
			$('#AbweichendeNachlieferadresse').off('change', this.SchalteAbweichendeLieferadresseEinOderAus);
			$('#Nachlieferung, #AbweichendeNachlieferadresse, #NachlieferungEPaper').prop('checked', false);
			$('#nachlieferadresse > div > input').val('');
			$('#BenutzerMussEingeloggtSeinFehler').removeClass('validate');

			$.post(this.setzeAboReklamationAktivUrl, { aboReklamationAktiv: false }, function (data) {
				if (window.calendar) {
					window.calendar.termine = data.ErscheinungstermineDaten;
				}
			}).then(self._nachWechselReklamationsModus.bind(self));
		}

		document.querySelectorAll('select').forEach(select => {
			if (select.parentElement.classList.contains('form-floating')) {
				jjk.refreshSelect2(select, { width: '100%' });
			} else {
				jjk.refreshSelect2(select);
			}
		});
	},

	_nachWechselReklamationsModus: function () {
		// Verteilschemata umschalten:
		const selektierteDatumsCheckbox = $(':checkbox:checked', '#calendarTableContainer');
		if (selektierteDatumsCheckbox.length) {
			this.SetDatum(selektierteDatumsCheckbox);
		}
		// Kalender mit neuen Terminen füllen:
		if (this.zeigeKalenderAn) {
			window.submitCalendar('None');
		}

		if (this.beginneMitVerteilschema) {
			this.GetVerteilschemata(null, null, daten => {
				this.VerteilschemataRendern(daten);
				this.IstSelektiertesVerteilschemaVorhanden(daten);
			});
		}
	},

	SchalteAbweichendeLieferadresseEinOderAus: function () {
		if ($(this).is(':checked')) {
			$('#nachlieferadresse').show();
		} else {
			$('#nachlieferadresse').hide();
		}
	},

	AnredeLeerzeileAusblenden: function () {
		jjk.initSelect2($('#SelectedAnredeValue'), {
			templateResult: function (data) {
				if (data.id === '0') {
					return null;
				}
				return data.text;
			},
		});
	},
};
